import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiBYOClusterActions = ActionsSet.make<DataKeys.KaapiBYOClusters>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiBYOClusters],
  cacheKey: DataKeys.KaapiBYOClusters,
})

export const listKaapiBYOClusters = kaapiBYOClusterActions.add(
  new ListAction<DataKeys.KaapiBYOClusters, { namespace: string }>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to list Kaapi BYOClusters', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiBYOClusters)
  }),
)
